import { CodeDeckPutSchema } from "callable-data-objects";
import { CallableInput } from "Components/Shared";
import FormSubmit from "Components/Shared/FormSubmit";
import { Field, Formik } from "formik";
import { useCodeDeck } from "Hooks/Endpoints";
import React from "react";
import { Card, Container, Form } from "semantic-ui-react";

const DeckForm = () => {
  const { deck, updateDeck, unselectDeck } = useCodeDeck();
  return (
    <Container fluid style={{ padding: "20px" }}>
      <Card fluid>
        <Card.Content>
          <Formik
            validateOnChange={false}
            initialValues={deck}
            validationSchema={CodeDeckPutSchema}
            onSubmit={(values, actions) => {
              updateDeck(values);
            }}
          >
            {({ handleSubmit, errors, validateField }) => (
              <Form onSubmit={handleSubmit}>
                <Field name="caller" label="Caller" component={CallableInput} />
                <Field name="called" label="Called" component={CallableInput} />
                <Field
                  name="category"
                  label="Category"
                  component={CallableInput}
                />
                <Field
                  name="country"
                  label="Country"
                  component={CallableInput}
                />
                <Field
                  name="countryCode"
                  label="Country Code"
                  component={CallableInput}
                />
                <FormSubmit
                  name="Update"
                  errors={errors}
                  onCancel={() => unselectDeck()}
                />
              </Form>
            )}
          </Formik>
        </Card.Content>
      </Card>
    </Container>
  );
};

export default DeckForm;
